import { FC } from 'react';
import {
  EntitySearchTextFilter,
  EntityTagPicker,
  UserListPicker,
  WbResponsiveTableToolbar,
} from '@agilelab/plugin-wb-platform';
import {
  OutputTypeFilter,
  OutputTypePicker,
} from '@agilelab/plugin-wb-practice-shaper';
import { configApiRef, useApi } from '@mainstage/core-plugin-api';
import { useScaffolderPageContext } from './context/useScaffolderPageContext';

const DEFAULT_OUTPUT_TYPE = 'all';

export const ScaffolderFilters: FC = () => {
  const { filters, updateFilters } = useScaffolderPageContext();
  const configApi = useApi(configApiRef);

  return (
    <WbResponsiveTableToolbar
      style={{ flex: 1 }}
      searchProps={{
        value: filters.text?.value,
        onChange: value => {
          updateFilters({ text: new EntitySearchTextFilter(value, configApi) });
        },
      }}
      onClear={() => {
        updateFilters({
          type: undefined,
          tags: undefined,
          user: undefined,
          text: undefined,
          generates: new OutputTypeFilter(DEFAULT_OUTPUT_TYPE),
        });
      }}
      marginBottom
    >
      <WbResponsiveTableToolbar.Filters>
        <OutputTypePicker initialFilter={DEFAULT_OUTPUT_TYPE} />
        <EntityTagPicker />
        <UserListPicker />
      </WbResponsiveTableToolbar.Filters>
    </WbResponsiveTableToolbar>
  );
};
